import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

export default function useFacetedFilter(
  items,
  { state, facetDefinitions, sortOptions } = {}
) {
  // Collect the facet values.
  const facets = Object.entries(facetDefinitions).reduce(
    (facets, [key, facet]) => {
      if (facet) {
        facets[key] = facet.prepare(
          items
            .filter(makeFilter(facet.state, facetDefinitions))
            .reduce(facet.reducer, facet.initialValue)
        );
      }
      return facets;
    },
    {}
  );

  // Filter the items on the selected facet values.
  const filteredItems = items.filter(makeFilter(state, facetDefinitions));

  // Sort the items.
  const sortedItems = state.sortBy
    ? orderBy(
        filteredItems,
        get(sortOptions, `${state.sortBy}.fields`),
        get(sortOptions, `${state.sortBy}.order`)
      )
    : filteredItems;

  return {
    items: sortedItems,
    facets,
  };
}

/**
 * Returns a filter function that checks
 * if a product matches all the selected facets.
 * @param {object} state            The filter state with the active filter values.
 * @param {object} facetDefinitions The facet objects.
 */
const makeFilter = (state, facetDefinitions) => product => {
  if (
    Object.values(facetDefinitions).find(
      facet => facet && !facet.matches(state)(product)
    )
  ) {
    return false;
  }
  return true;
};
